import Vue from "vue";
import auth from "./auth.services";
import users from "./user.services";
import roles from "./roles.services";
import profiles from "./profiles.services";
import typeRoles from "./typeRoles.services";
import paths from "./path.services";
import catalogosGenerales from "./catalogosGenerales";
import catalogosPlaza from "./catalogosPlaza";
import planillaServices from "./planilla.services";
import empleadoPlanilla from "./empleadoPlanilla";
import configuracionesParametrosSistema from "./configuracionesParametrosSistema.services";
import especificoGasto from "./especificoGasto.services";
import estructura from "./estructura.services";
import puestoUnidadService from "./puestoUnidad.service";
import cifradoPresupuestario from "./cifradoPresupuestario.service";
import categoriaPuestoService from "./categoriaPuesto.service";
import organigramaServices from "./organigrama.services";
import movimientos from "@/views/acciones-movimientos/services/index.js";
import peticiones from "./peticiones.services";
import catalogosPermutas from "./catalogosPermutas.services";
import renunciasServices from "./renuncias.services";
import aumento from "./aumento.services";
import vialidad from "../views/configuracionParametrosSistema/services/vialidad";
import categoriaDescuento from "./categoriaDescuento.services";
import gestionPlanillas from "./gestionPlanillas.services";
import planillaDescuentos from "./planillaDescuentos.service";
import nominaV2Services from "./nominaV2.services";
import plazasServices from "./plazas.services";
import reportes from "./reportes.services";
import reportesGenerales from "../views/reportes/services/reportesGenerales";
import historicoRenta from "./historicoRenta.services";
import rolesEmpleadosServices from "@/views/gestionRoles/rolesEmpleados/services/rolesEmpleados";
import gestionRol from "../views/gestionRoles/roles/services/gestionRol.services";
import resumenPlanillas from "./resumenPlanillas.services-";
import salarioMinimo from "./salarioMinimo.services";
import refrenda from "./refrenda.services";
import plantillasAmonestacionServices from "./plantillasAmonestacion.services";
import amonestacion from "../views/acciones-movimientos/amonestacion/services/amonestaciones";
import licencias from "../views/acciones-movimientos/licencia/services/licencias";
import agrupadoresAcciones from "./agrupadoresAcciones.services";
import ingresos from "./ingresos.services";
import configurarDescuento from "./configurarDescuento.services";
import configuracionesAdicionales from "../views/planilla/configuraciones-adicionales/services/configuracionesAdicionales.services";
import detallePlanillaUnica from "./detallePlanillaUnica.services";
import catalogoInstitucion from "./catalogoInstitucion.services";
import solicitudEliminarEmpleados from "./solicitudEliminarEmpleados.services";
import ramos from "./ramos.services";
import documentoPlaza from "./documentoPlaza.services";

import aumentoSalario from "./aumentoSalario";

import solicitudesRenuncias from "./solicitudesRenuncias.services";
import catalogoProceso from "./catalogoProceso";
import solicitudProceso from "./solicitudProceso";
import solicitudRenuncia from "./solicitudRenuncia";
import catalogoRenuncia from "./catalogoRenuncia";
import catalogoUsuariosCargaInicial from './catalogoUsuariosCargaInicial'
import establecimientos from "./establecimientos";
import cargaMasiva from "./cargaMasiva.service";
import catalogoEvaluaciones from "./catalogoEvaluaciones.services";
import tipoPlaza from "./tipoPlaza.services";
import notificaciones from "./notificaciones.services";
import usuarioDelegadoServices from "./usuarioDelegado.services";

Vue.prototype.services = {
  auth,
  users,
  roles,
  profiles,
  typeRoles,
  paths,
  catalogosGenerales,
  catalogosPlaza,
  planillaServices,
  empleadoPlanilla,
  configuracionesParametrosSistema,
  especificoGasto,
  estructura,
  puestoUnidadService,
  cifradoPresupuestario,
  categoriaPuestoService,
  organigramaServices,
  movimientos,
  peticiones,
  catalogosPermutas,
  renunciasServices,
  aumento,
  vialidad,
  categoriaDescuento,
  gestionPlanillas,
  planillaDescuentos,
  nominaV2Services,
  plazasServices,
  reportes,
  reportesGenerales,
  historicoRenta,
  rolesEmpleadosServices,
  gestionRol,
  resumenPlanillas,
  salarioMinimo,
  refrenda,
  plantillasAmonestacionServices,
  amonestacion,
  licencias,
  agrupadoresAcciones,
  ingresos,
  configurarDescuento,
  configuracionesAdicionales,
  detallePlanillaUnica,
  catalogoInstitucion,
  solicitudEliminarEmpleados,
  ramos,
  documentoPlaza,
  aumentoSalario,
  solicitudRenuncia,
  solicitudesRenuncias,
  catalogoRenuncia,
  solicitudProceso,
  catalogoProceso,
  catalogoUsuariosCargaInicial,
  establecimientos,
  cargaMasiva,
  catalogoEvaluaciones,
  tipoPlaza,
  notificaciones,
  usuarioDelegadoServices
};
